// @saas/interactions 纯函数工具（零依赖，保持可单测）

// normalizeBlank：复刻后端 interaction_grader.go 的 normalizeBlank
// （trim + width.Narrow 全角转半角 + ToLower），用于 fill_blank 逐空对错色的本地比对。
// 注意：真正判分在后端；这里只是 right=2 时的展示辅助——**两端归一化规则需同步演进**，
// 后端若调整 normalizeBlank，这里必须跟着改。
// - /[！-～]/ 即 U+FF01-U+FF5E 全角 ASCII 区，整体减 0xFEE0 映射回半角（２０２６→2026、Ｈ→H）
// - U+3000 全角空格单独转半角空格（不在上述区间内）
export function normalizeBlank (s) {
  return String(s || '').trim()
    .replace(/[！-～]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
    .replace(/\u3000/g, ' ')
    .toLowerCase()
}
